<template>
  <div class="forget">
    <ul class="language">
        <li>
            <img src="@/assets/image/language-icon.png" alt="">
            <span class="language-content">{{$t('language')}}</span>
            <ul>
                <li @click="changeLang('zh')">中文简体</li>
                <li @click="changeLang('en')">English</li>
            </ul>
        </li>
        <li style="padding:0">
            |
        </li>
        <li>
            <span>{{$t('backHome')}}</span>
        </li>
    </ul>
    <div class="login-div">
        <img src="@/assets/image/loginLogo.png" alt="">
        <Form :model="passwordModel" class="loginForm" ref="passwordForm" :rules="rules">
            <FormItem  prop="email">
                <Input v-model="passwordModel.email" :placeholder="$t('email')"></Input>
            </FormItem>
            <FormItem prop="verifyCode">
                <Input style="width:50%" v-model="passwordModel.verifyCode" :placeholder="$t('asd')"></Input>
                <Button class="sendBtn" :loading="!send" :disabled="countParams.disabled" @click="sendVerifyCode">{{countParams.txt}}</Button>
            </FormItem>
            <FormItem prop="password">
                <Input type="password"  v-model="passwordModel.password" :placeholder="$t('password')"></Input>
            </FormItem>
            <FormItem prop="conPassword">
                <Input type="password"  v-model="passwordModel.conPassword" :placeholder="$t('confirmPassword')"></Input>
            </FormItem>
            <FormItem>
                <Button class="loginBtn" :loading="!click" @click="save">{{$t('save')}}</Button>
            </FormItem>
            <FormItem>
                 <Button class="loginBtn" @click="toLogin">{{$t('loginAccount')}}</Button>
            </FormItem>
        </Form>
    </div>
    <div class="login-txt">
        <p class="footer_title">{{$t('footerTitle1')}}</p>
        <p class="footer_content">
            {{$t('topTips1')}}
        <span>{{$t('topTips2')}}</span>
        {{$t('topTips3')}}</p>
        </p>
        <p class="footer_title">{{$t('footerTitle2')}}</p>
        <p class="footer_content">{{$t('footerTips2')}}</p>
        <p class="footer_title">{{$t('footerTitle3')}}</p>
        <p class="footer_content">{{$t('footerTips3')}}</p>
        <p class="footer_content">{{$t('footerTips4')}}</p>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { setup } from '@/langs'
import _MIXINS_ from '@/mixins'

export default {
    name: 'Login',
    data() {
		const ps = /^[a-zA-Z]\w{5,17}$/
        const validatePass = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('loginTips2')));
            } else if(!ps.test(value)){
				callback(new Error(this.$t('passwordcheck')));
			} else {
                callback();
            }
        };
        const validatePassCheck = (rule, value, callback) => {
            if (value === '') {
                callback(new Error(this.$t('confirmPasswordCheck')));
            } else if (value !== this.passwordModel.password) {
                callback(new Error(this.$t('twoPasswordCheck')));
            } else {
                callback();
            }
        };
        return {
            passwordModel:{
                email: "",
                verifyCode:'',
                password: "",
                conPassword: ""
            },
            rules: {
                email: [
                    { required: true, message:this.$t('loginTips1') , trigger: 'blur' },
                    { type: 'email', message: this.$t('emailCheck'), trigger: 'blur' }
                ],
				verifyCode: [
				    { required: true, message:this.$t('asdPl'), trigger: 'blur' },
				],
                password: [
                    { validator: validatePass , trigger: 'blur' },
                ],
                conPassword: [
                    { validator: validatePassCheck , trigger: 'blur' },
                ]
            },
			send:true,
			click:true
        }
    },
	mixins: [_MIXINS_.countdown],
    methods: {
        changeLang(value){
            setup(value)
            location.reload()
        },
        toLogin(){
            this.$router.push({ path:'/login'})
        },
        sendVerifyCode(){
            this.$refs.passwordForm.validateField('email',(valid) => {
                if(!valid){
					if(this.send){
						this.send = false
					}else{
						return false
					}
                    this.$axios.get('/api/Public/SendEamilVerifyCode',{
						params:{
							email:this.passwordModel.email,
                            type:1,
                            key:'forgetpassword'
						}
					})
                    .then(async (res) => {
						this.send = true
                        if(res.data.status == 1){
							this.countdown()
                            this.$Message.success(res.data.msg)
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => {
						this.send = true
					})
                }
            })
        },
        save(){
            this.$refs.passwordForm.validate((valid) => {
                if (valid) {
					if(this.click){
						this.click = false
					}else{
						return false
					}
                    this.$axios.post('/api/Public/ForgetPassword', {
						email: this.passwordModel.email,
						verifyCode:this.passwordModel.verifyCode,
						password: this.$encrypt(this.passwordModel.password),
						conPassword: this.$encrypt(this.passwordModel.conPassword)
					})
                    .then(async (res) => {
						this.click = true
                        if(res.data.status == 1){
                            this.$Message.success(res.data.msg)
                            this.$router.push({ path:'/login'})
                        }else{
                            this.$Message.error(res.data.msg)
                        }
                    })
                    .catch((err) => {
						this.click = true
					})
                }
            })
        }
    }
}
</script>
<style lang="less">
    .forget{
        // height: 100%;
        // position: relative;
        position: relative;
        border: 1px solid transparent;
        .language{
            position: absolute;
            right: 2%;
            top: 20px;
            display: flex;
            flex-direction: row;
            li{
                display: flex;
                flex-direction: row;
                align-items: center;
                height: 58px;
                line-height: 58px;
                padding: 0 40px 0 14px;
                color: #d12937;
                cursor: pointer;
                position: relative;
                img{
                    margin-right: 10px;
                }
                .language-content{
                    position: relative;
                }
                .language-content:after{
                    content: "";
                    position: absolute;
                    right: -18px;
                    top: 28px;
                    border-top: 5px solid #d12937;
                    border-left: 5px solid transparent;
                    border-right: 5px solid transparent;
                }
                ul{
                    position: absolute;
                    top: 50px;
                    left: 0;
                    background: #f0f0f0;
                    width: 100%;
                    display: none;
                    li{
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                        justify-content: center;
                        color: #332c2b;
                        height: 50px;
                        line-height: 50px;
                    }
                    li:hover{
                        color: #d12937;
                    }
                }
            }
            li:hover ul{
                display: block;
            }
        }
        .login-div{
            width: 840px;
            height: 480px;
            // position: absolute;
            left:0; 
            right:0; 
            margin: auto;
            margin-top: 120px;
            img{
                margin: 80px auto;
                display: block;
            }
            .loginForm{
                display: flex;
                flex-direction: row;
                justify-content: space-between;
                flex-wrap: wrap;
                input,.ivu-select-selection{
                    min-height: 55px;
                    padding-left: 20px;
                    font-size: 16px;
                    border-color: #999999; 
                    border-radius: 10px;
                }
                .ivu-select-selection{
                    div{
                         min-height: 55px;
                         span{
                            min-height: 55px;
                            line-height: 55px;
                            padding: 0;
                            font-size: 16px;
                         }
                    }
                }
                .ivu-form-item-content{
                    display: flex;
                    flex-direction: row;
                    justify-content: space-between;
                    .sendBtn{
                        border-radius: 25px;
                        line-height: 55px;
                        height: 55px;
                        background:#ffffff;
                        color: #d12937;
                        width: 45%;
                        font-size: 20px;
                        outline: none;
                        border-color: #d02836;
                        box-shadow:  0 0 25px rgba(0,0,0,.3);
                        margin-top: 0;
                    }
                }
                button{
                    width:100%;
                    margin-top:30px
                }
                .loginBtn{
                    border-radius: 25px;
                    line-height: 55px;
                    height: 55px;
                    background:#d60433;
                    color: #ffffff;
                    min-width: 200px;
                    font-size: 20px;
                    outline: none;
                    box-shadow:  0 0 25px rgba(0,0,0,.3)
                }
                .regBtn{
                    border-radius: 25px;
                    line-height: 55px;
                    height: 55px;
                    background:#ffffff;
                    color: #d12937;
                    min-width: 200px;
                    font-size: 20px;
                    outline: none;
                    border-color: #d02836;
                    box-shadow:  0 0 25px rgba(0,0,0,0.25);
                    min-width: 370px;
                    
                }
                
            }
            .ivu-form-item{
                width: 48%;
            }
            .reg-tab{
                display: flex;
                flex-direction: row;
                margin-bottom: 30px;
                li{
                    width: 50%;
                    text-align: center;
                    padding-bottom: 18px;;
                    cursor: pointer;
                    font-size: 22px;
                    color: #332c2b;
                    border-bottom: 1px solid #e6e6e6;
                    position: relative;
                }
                li.active:after{
                    content: "";
                    position: absolute;
                    left: 50%;
                    bottom: 0px;
                    width: 76%;
                    height: 2px;
                    background-color: #d60433;
                    transform: translateX(-50%);
                    -webkit-transform: translateX(-50%);
                }
            }
        }
        .login-txt{
            width: 80%;
            // position: absolute;
            // bottom: 40px;
            left: 0;
            right: 0;
            margin: auto;
            margin-bottom: 40px;
            .footer_title{
                font-size: 16px;
                color: #8b8b8c;
                font-weight: 600;
                margin-bottom: 10px;
            }
            .footer_content{
                font-size: 14px;
                color: #8b8b8c;
                font-weight: 400;
                margin-bottom: 10px;
                span{
                    font-weight: 600;
                }
            }
        }
		.ivu-form-item-error {
			.ivu-input{
				border: 1px solid #ed4014!important;
			}
		}
    }
</style>